const { AX_POST, Local_SET_URL } = require('../../service/api')

let flight_expert_api_response = async ({
    origin,
    destination,
    depDate
}) => {
    return new Promise(async (resolve, reject) => {
        let ret = await AX_POST(Local_SET_URL + "/flight/search/flightexpert/oneway", {
            origin,
            destination,
            depDate
        })

        resolve(ret)
    })
}


let sharetrip_api_response = async ({
    origin,
    destination,
    depDate
}) => {
    return new Promise(async (resolve, reject) => {
        let ret = await AX_POST(Local_SET_URL + "/flight/search/sharetrip/oneway", {
            origin,
            destination,
            depDate
        })

        resolve(ret)
    })
}


let bdtickets_api_response = async ({
    origin,
    destination,
    depDate
}) => {
    return new Promise(async (resolve, reject) => {
        let ret = await AX_POST(Local_SET_URL + "/flight/search/bdtickets/oneway", {
            origin,
            destination,
            depDate
        })

        resolve(ret)
    })
}

let gozayaan_api_response = async ({
    origin,
    destination,
    depDate
}) => {
    return new Promise(async (resolve, reject) => {
        let ret = await AX_POST(Local_SET_URL + "/flight/search/gozayaan/oneway", {
            origin,
            destination,
            depDate
        })

        resolve(ret)
    })
}


let flight_searching_api_response = async ({
    origin,
    destination,
    depDate,
    source
}) => {
    return new Promise(async (resolve, reject) => {
        let ret = await AX_POST(Local_SET_URL + "/flight/searching", {
            origin,
            destination,
            depDate,
            source
        })
        resolve(ret)
    })
}



let flight_iata_searching_api_response = async ({
    searching
}) => {
    return new Promise(async (resolve, reject) => {
        let ret = await AX_POST(Local_SET_URL + "/iata/filter/searching", {
            searching
        })
        resolve(ret)
    })
}


let flight_multiple_searching_api_response = async (searching) => {
    return new Promise(async (resolve, reject) => {
        let ret = await AX_POST(Local_SET_URL + "/flight/multi/searching", searching)
        resolve(ret)
    })
}

let flight_multiple_searching_db_api_response = async (params) => {
    return new Promise(async (resolve, reject) => {
        let ret = await AX_POST(Local_SET_URL + "/flight/db/multi/search", params)
        resolve(ret)
    })
}


let flight_static_searching_db_api_response = async (params) => {
    return new Promise(async (resolve, reject) => {
        let ret = await AX_POST(Local_SET_URL + "/flight/db/static/search", params)
        resolve(ret)
    })
}



let login = async (params) => {
    return new Promise(async (resolve, reject) => {
        let ret = await AX_POST(Local_SET_URL + "/login/signin", params)
        resolve(ret)
    })
}


export {
    flight_expert_api_response,
    sharetrip_api_response,
    bdtickets_api_response,
    gozayaan_api_response,
    flight_searching_api_response,
    flight_iata_searching_api_response,
    flight_multiple_searching_api_response,
    flight_multiple_searching_db_api_response,
    flight_static_searching_db_api_response,
    login
}
